import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import NavigateLink from "../../../shared/components/features/navigateLink/navigateLink";
import { objectToNullNmmDomain } from "../../../student/utils/utils";
import pathRouts from "../../../shared/enums/pathRoute";
import classes from "./WidgetNmmCard.module.css";

const WidgetNmmCard = ({ StudyGroup }) => {

    const domains = useSelector(state => state.uiData.domains);
    const domain = useMemo(() => domains?.find(d => d.name === StudyGroup?.domainName) || objectToNullNmmDomain(StudyGroup?.domainName), [domains, StudyGroup?.domainName]);

    return (
        <NavigateLink link={`/${pathRouts.MYLEARNING}/domain/${StudyGroup?.id}/${StudyGroup?.domainName}`} showLoadingPage={false}>
            <div className={classes.WidgetDomainCard} style={{ cursor: "pointer" }}>
                <div className={classes.ColorBar} style={{ backgroundColor: domain.color }} />
                <div className={classes.DomainIconWrapper}>
                    <img src={domain?.widgetImage} alt={domain?.domainName} className={classes.WidgetDomainImg} />
                </div>
                <p className={classes.WidgetDomainTitle}>{StudyGroup?.name}</p>
            </div>
        </NavigateLink>
    );
};

export default WidgetNmmCard;